import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    demoteUser: boolean,
}

interface Variables {
    demoteUserId: string,
}

export const DEMOTE_USER: TypedDocumentNode<Result, Variables> = gql`
    mutation DemoteUser($demoteUserId: Int!){
        demoteUser(id: $demoteUserId)
    }       
`
